var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendar = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 18.5,
  height: 16.5,
  x: 2.75,
  y: 4.75,
  rx: 1.25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2 11.25h20M8.75 2.75v4.5M15.75 2.75v4.5"
})));
SvgCalendar.viewBox = '0 0 24 24';
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendar);
export default ForwardRef;